import type { ReactElement } from 'react';
import type { TeilnehmerVeranstaltung } from '@mcikm-vote/shared';

import { Karte } from '../../../components/Karte';
import { formatiereDatum } from '../../../formatierung';

/**
 * Warteraum (§19.2).
 *
 * Zeigt Veranstaltungsbezeichnung, Datum, Ort, die freigegebene Beschreibung und den Hinweis, dass
 * keine Abstimmung geöffnet ist. Die interne Notiz nach §6.1 kommt hier gar nicht erst an — der
 * Server überträgt sie nicht.
 */
export function WarteraumAnsicht({
  veranstaltung,
}: {
  veranstaltung: TeilnehmerVeranstaltung;
}): ReactElement {
  return (
    <div className="flex flex-col gap-4">
      <Karte>
        <h2 className="text-xl font-semibold">{veranstaltung.bezeichnung}</h2>
        <p className="text-text-gedaempft mt-1 text-sm">
          {formatiereDatum(veranstaltung.veranstaltungsdatum)}
          {veranstaltung.ort !== null && ` · ${veranstaltung.ort}`}
        </p>

        {veranstaltung.beschreibung !== null && (
          <p className="mt-4 whitespace-pre-line">{veranstaltung.beschreibung}</p>
        )}
      </Karte>

      <Karte className="text-center">
        <p className="text-lg font-medium">Derzeit ist keine Abstimmung geöffnet.</p>
        <p className="text-text-gedaempft mt-2 text-sm">
          Sobald eine Abstimmung geöffnet wird, erscheint sie hier von selbst. Diese Seite muss
          nicht neu geladen werden.
        </p>
      </Karte>
    </div>
  );
}
